<template>
	<footer class="footer">
		<div class="footer-content">
			<p v-html="$t('footer.text1')" />
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer'
	};
</script>

<style scoped lang="less">
	.footer{
		min-width: 100%;
		background-color: #fbfbfb;
		padding: 24px 0 ;
	}
	.footer-content{
		max-width: 960px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.8em;

	}
</style>
